/**
 * Created by Kristy on 25/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('medReportApprovals.history', {
                parent: 'medReportApprovals',
                url: '/history',
                data: {
                    authorities: ['ROLE_CHECKER']
                },
                templateUrl: 'app/displays/medReportApprovals/history/history.html',
                controller: 'MedReportApprovalsHistoryController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
